import React from 'react';
import { CardMedia, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function PanIndiaRoadSectionWeb() {
  const navigate = useNavigate();

  return (
    <>
      <Stack sx={{ maxWidth: '100%', px: '75px', mb: 5 }}>
        <>
          <CardMedia component="img" src="/assets/images/HomeMobile/12mw.webp" alt="Car History" />

          {/* <Stack direction="row" gap={2} py={7}>
            <Stack width="70%">
              
              <Box
                component="img"
                src="/assets/images/HomeMobile/panIndiaWeb.webp"
                alt="Warranty Image"
                sx={{
                  width: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: '0px ',
                }}
              />
            </Stack>
            <Stack width="30%" px={8} alignItems={'center'} justifyContent="center" textAlign="center">
              <Typography
                variant="caption"
                sx={{
                  fontSize: '14px',
                  color: '#FFFFFFDE',
                  lineHeight: 1.4,
                }}
              >
                Every vehicle comes with the assurance of up to 12 months warranty, covering key components to give you
                peace of mind and confidence on the road.
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" gap={2} py={7}>
            <Stack width="30%" px={5} alignItems={'left'} justifyContent="center" textAlign="left" gap={2}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  fontSize: '38px',
                  zIndex: 2,
                  background: 'linear-gradient(to right, #EA5D16, #F6851F)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  display: 'inline-block',
                  lineHeight: 1.2,
                }}
              >
                Upto 12 <br />
                Months
                <br /> Warranty
              </Typography>{' '}
              <Typography
                variant="caption"
                sx={{
                  fontSize: '14px',
                  color: '#FFFFFFDE',
                  lineHeight: 1.4,
                  pr: '3rem',
                }}
              >
                Every vehicle comes with the assurance of up to 12 months warranty, covering key components to give you
                peace of mind and confidence on the road.
              </Typography>
            </Stack>
            <Stack width="70%">
              <Box
                component="img"
                src="/assets/images/HomeMobile/12monthWeb.webp"
                alt="Warranty Image"
                sx={{
                  width: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: '0px ',
                }}
              />
            </Stack>
          </Stack>
          <Stack id="Inspect" direction="row" gap={2} py={7}>
            <Stack width="65%">
              <Box
                component="img"
                src="/assets/images/HomeMobile/InspectionVehicleWeb.webp"
                alt="Warranty Image"
                sx={{
                  width: '100%',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: '0px ',
                }}
              />
            </Stack>
            <Stack width="45%" px={5} gap={2} alignItems={'left'} justifyContent="center" textAlign="left">
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  fontSize: '38px',
                  zIndex: 2,
                  background: 'linear-gradient(to right, #EA5D16, #F6851F)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  display: 'inline-block',
                  lineHeight: 1.2,
                }}
              >
                Inspect <br />
                any Car With <br />
                Focus Warranty
              </Typography>{' '}
              <Typography
                variant="caption"
                sx={{
                  fontSize: '14px',
                  color: '#FFFFFFDE',
                  lineHeight: 1.4,
                  pr: '13rem',
                }}
              >
                Every vehicle comes with the assurance of up to 12 months warranty, covering key components to give you
                peace of mind and confidence on the road.
              </Typography>
              <Button
                sx={{
                  width: '100%',
                  backgroundColor: '#93642C',
                  color: '#e0e0e0',
                  fontSize: '16px',
                  borderRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 600,
                  justifyContent: 'center', // center text & icon
                  gap: 1,
                  paddingY: '10px', // reduce top & bottom padding
                  lineHeight: 1.2, // keep text snug vertically
                  minHeight: 'unset',
                  transition: 'background-color 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#7a5023',
                  },
                }}
              >
                Book an Inspection Service{' '}
              </Button>
            </Stack>
          </Stack> */}
        </>
      </Stack>

      <CardMedia component="img" src="/assets/images/HomeMobile/PanIndiaWeb.webp" alt="Car History" />

      <Stack
        sx={{ maxWidth: '100%', px: '75px', cursor: 'pointer' }}
        id="Inspect"
        onClick={() => navigate('/inspection')}
      >
        <CardMedia component="img" src="/assets/images/HomeMobile/inspectHomeWeb.webp" alt="Car History" />
      </Stack>
    </>
  );
}
